import { render, staticRenderFns } from "./SocialPostsModeles.vue?vue&type=template&id=0bd22b13&scoped=true&"
import script from "./SocialPostsModeles.vue?vue&type=script&lang=js&"
export * from "./SocialPostsModeles.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostsModeles.vue?vue&type=style&index=0&id=0bd22b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd22b13",
  null
  
)

export default component.exports